import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtGuestVoiceSection({}) {
  const isMobile = useMobile();
  const renderRow = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "#050f1d",
            padding: 18,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "#2c4d7a",
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} size={28} color={"#006aff"} />

        <NtText
          style={{
            marginLeft: 10,
            fontSize: 12,
            fontWeight: "500",
            color: "white",
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          flexDirection: isMobile ? "column-reverse" : "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* left side */}
        <View style={{ flex: 1, alignItems: "center" }}>
          <Image
            style={[
              {
                marginTop: isMobile ? 40 : 0,
                width: 150,
                height: 300,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
          />
        </View>
        {/* right side */}
        <View
          style={{ flex: isMobile ? 1 : 2, paddingLeft: 25, paddingRight: 55 }}
        >
          <NtSectionTitle style={{ textAlign: "left" }}>
            GUEST-VOICE
          </NtSectionTitle>
          <NtSectionDescription>
            Onboard/ship to Ship/Ship to Shore
          </NtSectionDescription>

          <NtSectionDescription style={{ color: "#006aff", marginTop: 15 }}>
            Passengers can receive calls with one or more of the following
            options:
          </NtSectionDescription>
          <View
            style={{
              marginTop: 30,
            }}
          >
            {renderRow("asterisk", "Your passengers connect to Ship WiFi", {})}
            {renderRow("asterisk", "Passengers use their own device", {
              marginTop: 10,
            })}
            {renderRow(
              "asterisk",
              "Ingegration w/ Passenger Management Systems",
              {
                marginTop: 10,
              }
            )}
          </View>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 60,
    marginBottom: 60,
  },
});

export default NtGuestVoiceSection;
